import { useEffect, useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import checkUserAllowed from "../../../utils/checkUserAllowed"
import OPERATORS from "../../../utils/operators"
import Button from "../../components/buttons/Button"
import Footer from "../../components/Footer"
import Header from "../../components/Header"
import { mtnLogo, otherNetworksLogo } from "../../../utils/assets"
const SelectNetwork = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [selectedNetwork, setSelectedNetwork] = useState('')
    
    // Get the intended destination (signup or signin) from navigation state
    const intendedDestination = location.state?.from || '/signup'

    const initSetSelectedNetwork = (name) => {
        setSelectedNetwork(name)
        if (name === 'MTN') {
            localStorage.setItem('afri_selected_operator', JSON.stringify(OPERATORS.afriplaymtnghana))
        } else {
            localStorage.setItem('afri_selected_operator', JSON.stringify(OPERATORS.afriplayghana))
        }
        
        // Navigate immediately after selection
        setTimeout(() => {
            navigate(intendedDestination)
        }, 300) // Small delay to show the selection visual feedback
    }

    useEffect(() => {
        const _check = async () => {
            await checkUserAllowed(false)
        }
        _check()
    }, [])

    return (
        <>
            <Header links={1} signup={5} />
            <div className="auth">
                <div className="auth-wrapper">
                    <div className="auth-container">
                        <div className="form-container select-network-wrapper">
                            <h2 className="select-network-header">Choose A Network</h2>
                            <ul className="network-container">
                                   <img src={mtnLogo}  onClick={() => initSetSelectedNetwork('MTN')} alt="MTN Logo" />
                                     <img src={otherNetworksLogo}  onClick={() => initSetSelectedNetwork('OTHERS')} alt="OTHER NETWORKS Logo" />
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default SelectNetwork